import styled from "styled-components"
import { Size, sizeToCss } from "./sizes"

const P = styled.p<{ size?: Size }>`
  ${props => {
    if (props.size) {
      return sizeToCss(props.size)
    }
    return sizeToCss("L")
  }}
`

export default P
